import { type SyntheticEvent, useCallback } from 'react'

import user from 'legacy/utils/user'

import { useConfigContext } from 'config/ui/ConfigContext'
import { PORTAL_LINK_SHIPMENTS_PATH } from 'rate-command-center/domain/PortalLinkRoute'

import { Contracts } from './Contracts'
import { Manage } from './Manage'
import { MenuList } from './Navigation.styles'
import { NavigationItem } from './NavigationItem'
import { Phone } from './Phone'
import { Profile } from './Profile'

const SHIPPER_GUIDE_PAGES_URL = `/#${PORTAL_LINK_SHIPMENTS_PATH}?utm_source=carrierguide&utm_medium=link_menu&utm_campaign=all_in_one`

export function PrivateMenu() {
  const isCarrier = user.get('entityType') === 'carrier'

  return (
    <MenuList>
      {isCarrier ? <CarrierMenu /> : <BrokerMenu />}
      <Profile />
    </MenuList>
  )
}

function BrokerMenu() {
  const { enableShipperGuidePage } = useConfigContext()

  const showShipperGuideMenuItem = enableShipperGuidePage.toBoolean()

  const handleOpenShipperGuidePages = useCallback((event: SyntheticEvent) => {
    event.preventDefault()
    window.open(SHIPPER_GUIDE_PAGES_URL, '_blank', 'noopener,noreferrer')
  }, [])

  return (
    <>
      <NavigationItem title="Book" url="/loads" />
      <NavigationItem title="Contracts" url="/rfp" />
      <NavigationItem title="My Loads" url="/shipments/shipper-loads" />
      {showShipperGuideMenuItem && (
        <NavigationItem
          onClick={handleOpenShipperGuidePages}
          title="ShipperGuide"
          url={SHIPPER_GUIDE_PAGES_URL}
        />
      )}
      <NavigationItem title="Manage" url="/fleet" />
    </>
  )
}

function CarrierMenu() {
  const { enableShipperGuidePage } = useConfigContext()

  const showShipperGuideMenuItem = enableShipperGuidePage.toBoolean()

  const handleOpenShipperGuidePages = useCallback((event: SyntheticEvent) => {
    event.preventDefault()
    window.open(SHIPPER_GUIDE_PAGES_URL, '_blank', 'noopener,noreferrer')
  }, [])

  return (
    <>
      <Phone />
      <NavigationItem title="Book" url="/loads" />
      <Contracts />
      <NavigationItem title="My Loads" url="/shipments/loadsmart-loads" />
      {showShipperGuideMenuItem && (
        <NavigationItem
          onClick={handleOpenShipperGuidePages}
          title="ShipperGuide"
          url={SHIPPER_GUIDE_PAGES_URL}
        />
      )}
      <Manage />
    </>
  )
}
